import React, { useEffect, useState } from "react";
import Content from "../../layouts/Content";
import Theme from "../../theme.module.css";
import Style from "./HomeHero.module.css";

export default function HomeHero() {

    const [isFirstRender, setIsFirstRender] = useState(true);

    useEffect(() => {
        setIsFirstRender(false);
    }, [])

    return (
        <section className={`${Theme.section} ${Theme.dark} ${Style.homeHero} ${isFirstRender ? '' : Style.entered}`}>
            <div className={`${Theme.darkGradientWide} ${Style.gradientWide}`} style={{backgroundImage: `url(${require('../../assets/darkGradientWide.jpg')})`}}>
                
            </div>
            {/* <Content> */}
                <img src={require('../../assets/gnar-software-white.png')} alt="gnar software" className={Style.logo}/>
                <div className={`${Theme.vh100} ${Style.inner}`}>
                    <h1>Solving business challenges with software</h1>
                </div>
                <img src={require('../../assets/omni_shape_1.svg').default} alt="" className={Style.omniShape}/>
                {/* <div className={Style.scrollDown}>
                    <p>scroll</p>
                    <img src={require('../../assets/arrow1.svg').default} alt="" />
                </div> */}
            {/* </Content> */}
        </section>
    );
}